import React, { useEffect } from 'react';
import { clientInfo } from '@meitu/pc-bridge';
import { getFramework, HOTKEY_TYPE, useIdentity } from '@/framework';
import { ClipboardPlugin } from './controller';

export const ClipboardPluginView = React.memo(() => {
    const identity = useIdentity();
    const framework = getFramework(identity);

    // 复制、粘贴、剪切
    useEffect(() => {
        const handleCopy = (e: ClipboardEvent | null) => {
            e?.preventDefault();
            // 清空剪切板(兼容 windows 内嵌)
            e?.clipboardData?.setData('text/plain', clientInfo.isClient ? '\r' : '');
            framework.getInstance(ClipboardPlugin).copy(e);
        };

        const handleCut = (e: ClipboardEvent | null) => {
            e?.preventDefault();
            // 清空剪切板(兼容 windows 内嵌)
            e?.clipboardData?.setData('text/plain', clientInfo.isClient ? '\r' : '');
            framework.getInstance(ClipboardPlugin).cut(e);
        };

        const handlePaste = async (e: ClipboardEvent | null) => {
            framework.getInstance(ClipboardPlugin).paste(e);
        };

        const handleFixedPaste = () => {
            // HACK: 触发原位置粘贴事件
            const e = new ClipboardEvent('paste');

            document.dispatchEvent(e);
        };

        const handlers = [
            framework.events.on(HOTKEY_TYPE.paste, handlePaste),
            framework.events.on(HOTKEY_TYPE.copy, handleCopy),
            framework.events.on(HOTKEY_TYPE.cut, handleCut),
            framework.events.on(HOTKEY_TYPE.fixedPaste, handleFixedPaste),
        ];

        return () => {
            handlers.forEach((handler) => framework.events.off(handler));
        };
    }, []);

    return null;
});
